import { type ReactNode, useEffect } from "react";

import {
  VoicePlaybackContext,
  useCreateVoicePlaybackStore,
} from "../../store/voicePlayback";

export function VoicePlaybackProvider({ children }: { children: ReactNode }) {
  const store = useCreateVoicePlaybackStore();

  useEffect(() => store.getState().bind(), [store]);

  return (
    <VoicePlaybackContext.Provider value={store}>
      {children}
    </VoicePlaybackContext.Provider>
  );
}
